import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 py-8 border-t border-slate-800" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-17">
        <p className="text-slate-500 text-sm" data-id="element-18">
          © {new Date().getFullYear()} Triatlón en 6HS. Todos los derechos
          reservados.
        </p>
        <p className="text-slate-600 text-xs mt-2" data-id="element-19">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}